// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_Zo_","cls2":"ReferenceCard-cls2_A5p ReferenceCard-cls1_Zo_"};